import React, { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { useLocation } from 'react-router'

const Tabing = ({ topTabs, style , className}) => {
    const [activeTab, setActiveTab] = useState("")
    const [one] = useState(1);
    const [two] = useState(2);
    const [three] = useState(3)

    const location = useLocation();

    useEffect(() => {
        let pathName = location.pathname;

        let innerOne = one;
        let innerTwo = two;
        let innerThree = three;

        if (pathName.split("/")[innerOne] === "leave22") {
            if (!pathName.split("/")[innerTwo]) {
                setActiveTab('my-data')
            } else if (pathName.split("/")[innerTwo] === 'team' || pathName.split("/")[innerTwo] === 'teams') {
                setActiveTab('team')
            } else if (pathName.split("/")[innerTwo] === 'holiday') {
                setActiveTab('holiday')
            } else {
                if (!pathName.split("/")[innerThree]) {
                    setActiveTab('my-data')
                } else {
                    setActiveTab(pathName.split("/")[innerThree])
                }
            }
        } else if(pathName.split("/")[innerTwo] == 'analytics'){
            setActiveTab("report-analytics")
        }  else if(pathName.split("/")[innerTwo] === 'team' || pathName.split("/")[innerTwo] === 'teams'){
            setActiveTab("team")
        } else {
            setActiveTab(pathName)
        }
    }, [location.pathname, one, two, three])

    return (
        <>
            <div className={style.headerTop_tabs}>
                {topTabs?.map((eachTab, i) => {
                    return (
                        <Link key={i} to={eachTab?.url} className={`${style.headerTop_tabs__items}  ${className?.headerTop_tabs__items} ${(activeTab.split("/")[1] == eachTab?.activeKey || activeTab.split("/")[0] == eachTab?.activeKey || activeTab.split("/")[2] == eachTab?.activeKey) ? style.active : ""}`} onClick={(e) => { if (!eachTab?.url) {
                                e.preventDefault(); // 👈 prevent navigation
                                return;
                            } setActiveTab(eachTab?.activeKey) }}>
                            <div className={style.icon}>
                                {eachTab?.icon}
                            </div>

                            <span>{eachTab?.name}</span>
                        </Link>
                    )
                })}
            </div>
        </>
    )
}

export default Tabing
